import React from 'react';

import { Divider } from '@rbilabs/universal-components';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { TopOrderStatusBar } from 'components/top-order-status-bar';
import { useTopOrderStatusBar } from 'components/top-order-status-bar/use-top-order-status-bar';
import { TopServiceMode } from 'components/top-service-mode';
import { useSmartAlert } from 'state/smart-alert';
import { useStoreContext } from 'state/store';
import { primitive } from 'styles/constants/primitives';

export const ServiceModeBar = ({
  hideTsm = false,
  hideTopOrderStatusBar = false,
}: {
  hideTsm?: boolean;
  hideTopOrderStatusBar?: boolean;
}) => {
  const { noStoreSelected } = useStoreContext();

  const topOrderStatusBarData = useTopOrderStatusBar();
  const showTopOrderStatusBar =
    !!topOrderStatusBarData.heading &&
    topOrderStatusBarData.queryWasExecuted &&
    !hideTopOrderStatusBar;

  const showTopServiceMode = !noStoreSelected && !hideTsm;

  const { tsmSmartAlert } = useSmartAlert();

  const getLayoutContainerBackgroundColor = () => {
    if (showTopOrderStatusBar) {
      return primitive.bk.$crunchyGreen;
    }
    if (tsmSmartAlert) {
      return primitive.bk.$errorLight;
    }
    return primitive.bk.$mayoEggWhite;
  };

  return (
    <>
      {showTopOrderStatusBar || (showTopServiceMode && <Divider />)}
      <CenteredRowContainer
        containerStyle={{
          backgroundColor: getLayoutContainerBackgroundColor(),
        }}
        standardPadding
      >
        {showTopOrderStatusBar ? (
          <TopOrderStatusBar data={topOrderStatusBarData} />
        ) : (
          showTopServiceMode && <TopServiceMode />
        )}
      </CenteredRowContainer>
    </>
  );
};
